import { requestApi } from '../util/network'
export const getLiveList =
    (data) =>
      requestApi(
        '/live/get_live_list',
        'POST',
        data
      )
export const getMiniproLiveList =
    (data) =>
      requestApi(
        '/live/get_minipro_live_list',
        'POST',
        data
      )
export const getLiveInfo =
    (live_apply_id) =>
      requestApi(
        '/member_live/get_live_info',
        'POST',
        {
          'live_apply_id': live_apply_id
        },
        'member'
      )
export const joinLive =
    (live_apply_id, client_id) =>
      requestApi(
        '/member_live/join_live',
        'POST',
        {
          'live_apply_id': live_apply_id,
          'client_id': client_id
        },
        'member'
      )
export const leaveLive =
    (live_apply_id, client_id) =>
      requestApi(
        '/member_live/leave_live',
        'POST',
        {
          'live_apply_id': live_apply_id,
          'client_id': client_id
        },
        'member'
      )
export const addLike =
    (live_apply_id) =>
      requestApi(
        '/member_live/add_like',
        'POST',
        {
          'live_apply_id': live_apply_id
        },
        'member'
      )
export const addGift =
    (live_apply_id) =>
      requestApi(
        '/member_live/add_gift',
        'POST',
        {
          'live_apply_id': live_apply_id
        },
        'member'
      )
export const getLiveInfoss =
    (class_id,search,page) =>
      requestApi(
        '/live/list',
        'POST',
        {
          'class_id': class_id,
          'search': search,
          "page":page
        },
        'home'
      )
export const joinLiveshop =
    (store_id) =>
      requestApi(
        '/live/shop',
        'POST',
        {
          'store_id': store_id,
        },
        'home'
      )
export const joinLivesss =
    (store_id) =>
      requestApi(
        '/live/shop_live',
        'POST',
        {
          'store_id': store_id,
        },
        'home'
      )
export const LiveLindexList =
    (data) =>
      requestApi(
        '/live/index',
        'POST',
        {
          
        },
        'home'
      )      
export const getlivelists =
    (type,page) =>
      requestApi(
        '/live/live_list',
        'POST',
        {
          'type': type,
          "page":page
        },
        'home'
      )       
